import React, { Component } from "react";
import axios from "axios";
import NvidiaContainer from "../../hoc/NvidiaContainer/NvidiaContainer";
import ConsentList from "../../components/ConsentList/ConsentList";
import Input from "../../components/UI/Input/Input";
import Button from "../../components/UI/Button/Button";
import Spinner from "../../components/UI/Spinner/Spinner";
import { withTranslation } from "react-i18next";
import {
  getUrlParamByName,
  isUrlParamByName,
  checkDobError,
  parseConsent,
  getVoltronBase,
  getStarfleetBase,
  isCNTLD,
  isCOMTLD,
} from "../../utils/helpers";
import Starfleet from "../../services/Starfleet";
import { CONSENT_ASKED_URL, VALIDATIONS } from "./config";
import { withRouter } from "react-router-dom";
const SUPPORTED_LOCALES = require("../../../config/config").SUPPORTED_LOCALES;

import classes from "./PrivacySettings.css";

const starfleet = new Starfleet(getStarfleetBase(), {
  storageName: LOCAL_STORAGE_ITEM,
});

class PrivacySettings extends Component {
  state = {
    clientId: getUrlParamByName(this.props.location.search, "client_id"),
    session: starfleet.getUserSession(),
    gamingConsent: {
      trackBehavioralData: {
        value: false,
        required: isUrlParamByName(
          this.props.location.search,
          "trackBehavioralData"
        ),
      },
      trackTechnicalData: {
        value: false,
        required: isUrlParamByName(
          this.props.location.search,
          "trackTechnicalData"
        ),
      },
      opt_in: {
        value: false,
        required: isUrlParamByName(this.props.location.search, "opt_in"),
      },
      show: false,
      version: null,
    },
    enterpriseConsent: {
      trackBehavioralData: {
        value: false,
        required: isUrlParamByName(
          this.props.location.search,
          "trackBehavioralData"
        ),
      },
      trackTechnicalData: {
        value: false,
        required: isUrlParamByName(
          this.props.location.search,
          "trackTechnicalData"
        ),
      },
      opt_in: {
        value: false,
        required: isUrlParamByName(this.props.location.search, "opt_in"),
      },
      show: false,
      version: null,
    },
    dob: {
      required: isUrlParamByName(this.props.location.search, "dob"),
      value: "",
      type: "text",
      error: null,
    },
    loading: true,
    formValid: !isUrlParamByName(this.props.location.search, "dob"),
    profileVersion: null,
  };

  componentDidMount() {
    let supportedLocale = SUPPORTED_LOCALES.includes(
      this.props.locale.replace("_", "-").toLowerCase()
    )
      ? this.props.locale
      : "en_US";
    const [lang] = this.props.locale.split("_");
    this.setState({
      gamingConsent: {
        ...this.state.gamingConsent,
        show: this.isServiceTypePresent("gaming"),
        version: this.getServiceTypeVersion("gaming"),
      },
      enterpriseConsent: {
        ...this.state.enterpriseConsent,
        show: this.isServiceTypePresent("enterprise"),
        version: this.getServiceTypeVersion("enterprise"),
      },
    });
    if (this.isServiceTypePresent("enterprise")) {
      axios
        .get(
          `${AEM_CONSENT_CONTENT}${supportedLocale}.enterprise.${this.getServiceTypeVersion(
            "enterprise"
          )}.json`,
          { params: { v: 2 } }
        )
        .then((response) => {
          const data =
            response.data.consent.enterprise[
              this.getServiceTypeVersion("enterprise")
            ][lang];

          this.setState({
            loading: false,
            dob: { ...this.state.dob, ...data?.dob },
            enterpriseConsent: {
              consentTitle: data.consentTitle,
              ...this.state.enterpriseConsent,
              trackBehavioralData: {
                ...this.state.enterpriseConsent.trackBehavioralData,
                ...data.trackBehavioralData,
              },
              trackTechnicalData: {
                ...this.state.enterpriseConsent.trackTechnicalData,
                ...data.trackTechnicalData,
              },
              opt_in: {
                ...this.state.enterpriseConsent.opt_in,
                ...data.opt_in,
              },
            },
          });
        });
    }

    if (this.isServiceTypePresent("gaming")) {
      axios
        .get(
          `${AEM_CONSENT_CONTENT}${supportedLocale}.gaming.${this.getServiceTypeVersion(
            "gaming"
          )}.json`,
          { params: { v: 2 } }
        )
        .then((response) => {
          const data =
            response.data.consent.gaming[this.getServiceTypeVersion("gaming")][
              lang
            ];

          this.setState({
            loading: false,

            dob: { ...this.state.dob, ...data?.dob },
            gamingConsent: {
              consentTitle: data.consentTitle,
              ...this.state.gamingConsent,
              trackBehavioralData: {
                ...this.state.gamingConsent.trackBehavioralData,
                ...data.trackBehavioralData,
              },
              trackTechnicalData: {
                ...this.state.gamingConsent.trackTechnicalData,
                ...data.trackTechnicalData,
              },
              opt_in: { ...this.state.gamingConsent.opt_in, ...data.opt_in },
            },
          });
        });
    }

    starfleet
      .getUserProfile(this.state.session.access_token)
      .then((response) => {
        const parsedConsent = parseConsent(response.consent);
        this.setState({ profileVersion: response.meta.version });
        for (let key in parsedConsent) {
          this.setState({
            [key]: {
              ...this.state[key],
              trackBehavioralData: {
                ...this.state[key].trackBehavioralData,
                ...parsedConsent[key].trackBehavioralData,
              },
              trackTechnicalData: {
                ...this.state[key].trackTechnicalData,
                ...parsedConsent[key].trackTechnicalData,
              },
            },
          });
        }
      });
  }

  handleDobChange = (event) => {
    const error = checkDobError(event.target.value, this.state.dob.format);
    this.setState({
      formValid: !error,
      dob: { ...this.state.dob, value: event.target.value, error },
    });
  };

  handleConsentChange = (event, serviceType) => {
    const newConsent = {
      ...this.state[serviceType],
      [event.target.name]: {
        ...this.state[serviceType][event.target.name],
        value: event.target.checked,
      },
    };
    this.setState({ [serviceType]: newConsent });
  };
  isServiceTypePresent = (serviceType) => {
    return [
      this.props.match.params.serviceType1,
      this.props.match.params.serviceType2,
    ].includes(serviceType);
  };
  getServiceTypeVersion = (serviceType) => {
    if (this.isServiceTypePresent(serviceType)) {
      return this.props.match.params.serviceType1 === serviceType
        ? this.props.match.params.version1
        : this.props.match.params.serviceType2 === serviceType
        ? this.props.match.params.version2
        : null;
    }
    return null;
  };
  createFormData = () => {
    const formData = [];
    if (this.isServiceTypePresent("gaming")) {
      formData.push({
        clientId: this.state.session.client_id,
        timestamp: new Date().toISOString(),
        consentAsked: `${
          CONSENT_ASKED_URL["gaming"][ENV]
        }gaming/${this.getServiceTypeVersion("gaming")}`,
        consentGranted: [
          `trackBehavioralData:${this.state.gamingConsent.trackBehavioralData.value}`,
          `trackTechnicalData:${this.state.gamingConsent.trackTechnicalData.value}`,
        ],
      });
    }
    if (this.isServiceTypePresent("enterprise")) {
      formData.push({
        clientId: this.state.session.client_id,
        timestamp: new Date().toISOString(),
        consentAsked: `${
          CONSENT_ASKED_URL["enterprise"][ENV]
        }enterprise/${this.getServiceTypeVersion("enterprise")}`,
        consentGranted: [
          `trackBehavioralData:${this.state.enterpriseConsent.trackBehavioralData.value}`,
          `trackTechnicalData:${this.state.enterpriseConsent.trackTechnicalData.value}`,
        ],
      });
    }
    return formData;
  };
  handleSubmit = (event) => {
    this.setState({
      loading: true,
    });
    event.preventDefault();
    axios
      .post(getVoltronBase() + SET_CONSENTS, this.createFormData(), {
        headers: {
          idToken: this.state.session.id_token,
          accessToken: this.state.session.access_token,
          "content-type": "application/json",
          "Match-Version": this.state.profileVersion,
        },
      })
      .finally(() => {
        const redirectUri = getUrlParamByName(
          this.props.location.search,
          "redirect_uri"
        );
        // Making sure the redirect uri is of NVIDIA domain
        if (redirectUri.match(VALIDATIONS.urlRegex))
          location.href = redirectUri;
      });
  };

  render() {
    if (this.state.loading === true) {
      return (
        <div className={classes.SpinnerContainer}>
          <Spinner inline={true} />
        </div>
      );
    }
    let gamingConsents = [],
      enterpriseConsents = [];
    for (let key in this.state.gamingConsent) {
      gamingConsents.push({ name: key, ...this.state.gamingConsent[key] });
    }
    for (let key in this.state.enterpriseConsent) {
      enterpriseConsents.push({
        name: key,
        ...this.state.enterpriseConsent[key],
      });
    }
    //removing consents that are not required
    //making sure the order is consistent after consent update ( safari key iterator)
    gamingConsents = gamingConsents
      .filter((consent) => consent.required)
      .sort((consentA, consentB) => {
        return consentA.name < consentB.name ? -1 : 1;
      });

    enterpriseConsents = enterpriseConsents
      .filter((consent) => consent.required)
      .sort((consentA, consentB) => {
        return consentA.name < consentB.name ? -1 : 1;
      });

    const dobElement = this.state.dob.required ? (
      <>
        <label className={classes.SubTitle}>{this.state.dob.title}</label>
        <Input
          type={this.state.dob.type}
          value={this.state.dob.value}
          changeHandler={this.handleDobChange}
          placeholder={this.state.dob.format}
          error={this.state.dob.error}
        />
      </>
    ) : null;

    return (
      <main className={classes.PrivacySettings}>
        <h1 className={classes.Title}>
          {this.props.t("Finish setting up your NVIDIA profile")}
        </h1>
        <p>
          {(new URLSearchParams(location.href).get("region") === "CN") &
          (this.props.locale === "en_US")
            ? this.props.t(
                "Your NVIDIA account allows you to manage preferences, subscriptions, and more across enterprise and developer content on NVIDIA.com."
              )
            : this.props.t(
                "Your NVIDIA account allows you to manage preferences, subscriptions, and more across gaming, enterprise, and developer content on NVIDIA.com."
              )}
        </p>

        <form onSubmit={this.handleSubmit}>
          {this.state.gamingConsent.show && (
            <NvidiaContainer>
              <h2>{this.state.gamingConsent.consentTitle}</h2>
              <ConsentList
                handleConsentChange={(e) =>
                  this.handleConsentChange(e, "gamingConsent")
                }
                consents={gamingConsents}
                type="gaming"
              />
              {dobElement}
            </NvidiaContainer>
          )}
          {this.state.enterpriseConsent.show && (
            <NvidiaContainer>
              <h2>{this.state.enterpriseConsent.consentTitle}</h2>
              <ConsentList
                handleConsentChange={(e) =>
                  this.handleConsentChange(e, "enterpriseConsent")
                }
                consents={enterpriseConsents}
                type="enterprise"
              />
            </NvidiaContainer>
          )}
          <div className={classes.ButtonContainer}>
            <Button
              disabled={!this.state.formValid}
              label={this.props.t("submit")}
              type="submit"
            />
          </div>
        </form>
      </main>
    );
  }
}
export default withTranslation()(withRouter(PrivacySettings));
